import type { SVGProps } from "react";

export const HowItWorksBuildingGraphics = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 800 400" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* City skyline */}
      <rect
        x="50"
        y="250"
        width="40"
        height="100"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="100"
        y="200"
        width="50"
        height="150"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="160"
        y="220"
        width="40"
        height="130"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="210"
        y="180"
        width="45"
        height="170"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      {/* Houses */}
      <path
        d="M300 280 L320 250 L340 280 Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="305"
        y="280"
        width="30"
        height="40"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <path
        d="M380 270 L395 245 L410 270 Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="385"
        y="270"
        width="25"
        height="35"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      {/* Industrial structures */}
      <rect
        x="450"
        y="240"
        width="60"
        height="80"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="520"
        y="260"
        width="50"
        height="60"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.1"
      />
    </svg>
  );
};
